import React, {Component} from 'react';
import {connect} from "react-redux";
import CombinationChecking from "./combination-checking";
import CombinationExposure from "./combination-exposure";
import StackCombinationsTotalMinExposure from "./stack-combinations-total-min-exposure";

class CombinationOptions extends Component {
    render() {
        const {stacking} = this.props;
        const combinations = stacking.getCombinations();

        const combinationBlocks = Object.keys(combinations).map(comboKey => (
            <div key={comboKey} className="stack-box">
                <CombinationChecking comboKey={comboKey}/>
                <div className="min-max-group">
                  <div className="percent-in">
                      <CombinationExposure
                          exposureType="min"
                          comboKey={comboKey}/>
                      <span className="percent">%</span>
                  </div>
                  <div className="percent-in">
                      <CombinationExposure
                          exposureType="max"
                          comboKey={comboKey}/>
                      <span className="percent">%</span>
                  </div>
                </div>
            </div>
        ));

        return (
            <div className="nhl-stack-combinations">
                <div className="heading-box">
                  <h3>Choose stack combinations</h3>
                  <StackCombinationsTotalMinExposure />
                </div>
                <div className="stack-box-holder">
                  {combinationBlocks}
                </div>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {
        nhlLegacyTeamStacking,
    } = state;

    return {
        stacking: nhlLegacyTeamStacking,
    }
}

export default connect(mapStatesToProps)(CombinationOptions);
